import React from "react";
import {Dot} from "./Miles";

export const Distances = ({miles, time} : {miles?: number| undefined, time?: number}) => {
    if (miles == null) {
        return (
            <>
                <Dot/>
                <span>Unavailable</span>
            </>
        );
    }

    return (
        <>
            <Dot/>
            <span>{miles} mi</span>
            {time && (
                <>
                    <Dot/>
                    <span>{Math.round(time / 60000)} Minutes</span>
                </>
            )}
        </>
    );
};
